// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iMD7k{background:#fff}.fREjZ{margin:0 0 4px;font-family:\"Merriweather\",serif;font-size:22px;font-weight:700;line-height:32px}.Gzqut{display:flex;align-items:center;padding:16px 0;color:#2d2d2d;font-size:16px;line-height:22px;transition:color .2s}.Gzqut>span{-webkit-line-clamp:2;-webkit-box-orient:vertical;display:block;display:-webkit-box;overflow:hidden;max-height:44px}.Gzqut:active{-webkit-tap-highlight-color:rgba(0,0,0,0);color:rgba(45,45,45,.8)}@media(any-hover:hover){.Gzqut:hover{color:rgba(45,45,45,.8)}}.Gzqut+.Gzqut{border-top:1px solid #e2e2e2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "iMD7k",
	"title": "fREjZ",
	"item": "Gzqut"
};
module.exports = ___CSS_LOADER_EXPORT___;
